import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pa-2" }

import { PartidaTorneoDTO } from "@/interfaces/Partidas";
import { computed, ref } from "vue";

import ModalModificarPairingEquipos from "./ModalModificarPairingEquipos.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardEmparejamientosGestion',
  props: {
    partidas: {},
    numeroRonda: {},
    idTorneo: {}
  },
  setup(__props: any) {

const props = __props;

const equipos1Old = ref();
const equipos2Old = ref();
const showModalModificacion = ref<boolean>();

const emparejamientosUnicos = computed(() => {
  const set = new Set<string>();
  const resultado: {
    equipo1: string;
    equipo2: string;
    idEquipo1: number;
    idEquipo2: number;
  }[] = [];
  props.partidas
    .filter((p) => p.numeroRonda === props.numeroRonda)
    .forEach((partida) => {
      const equipoA = partida.nombreEquipo1?.trim();
      const equipoB = partida.nombreEquipo2?.trim();
      const clave = [equipoA, equipoB].sort().join("|"); // Normaliza para detectar duplicados sin importar el orden

      if (!set.has(clave)) {
        set.add(clave);
        resultado.push({
          equipo1: equipoA as string,
          equipo2: equipoB as string,
          idEquipo1: partida.idEquipo1 as number,
          idEquipo2: partida.idEquipo2 as number,
        });
      }
    });

  return resultado;
});

const equiposDisponibles = computed(() => {
  const equiposMap = new Map<number, string>();
  props.partidas.forEach((p) => {
    if (p.idEquipo1 && p.nombreEquipo1)
      equiposMap.set(p.idEquipo1, p.nombreEquipo1.trim());
    if (p.idEquipo2 && p.nombreEquipo2)
      equiposMap.set(p.idEquipo2, p.nombreEquipo2.trim());
  });
  return Array.from(equiposMap.entries()).map(([id, nombre]) => ({
    id,
    nombre,
  }));
});

function editarEmparejamiento(id1: number, id2: number) {
  equipos1Old.value =
    equiposDisponibles.value.find((e) => e.id === id1) ?? null;
  equipos2Old.value =
    equiposDisponibles.value.find((e) => e.id === id2) ?? null;
  showModalModificacion.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_hover, null, {
        default: _withCtx(({ props: hoverProps }) => [
          _createVNode(_component_v_card, _mergeProps(hoverProps, {
            class: "match-card mt-3 mx-auto",
            width: "100%",
            "max-width": "600",
            elevation: "2"
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emparejamientosUnicos.value, (mesa, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "mb-2"
                    }, [
                      _createElementVNode("strong", null, "Mesa " + _toDisplayString(index + 1) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(mesa.equipo1) + " vs " + _toDisplayString(mesa.equipo2) + " ", 1),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: ($event: any) => (editarEmparejamiento(mesa.idEquipo1, mesa.idEquipo2))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-pencil")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        _: 1
      })
    ]),
    (showModalModificacion.value)
      ? (_openBlock(), _createBlock(ModalModificarPairingEquipos, {
          key: 0,
          modelValue: showModalModificacion.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModalModificacion).value = $event)),
          equipoOriginal1: equipos1Old.value,
          equipoOriginal2: equipos2Old.value,
          numeroRonda: _ctx.numeroRonda,
          idTorneo: props.idTorneo
        }, null, 8, ["modelValue", "equipoOriginal1", "equipoOriginal2", "numeroRonda", "idTorneo"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})